import { Box, Breadcrumbs, Button, Grid, Link, Typography } from '@mui/material';
import Seperator from '../../assets/icons/breadcrumbs-seperator.svg';
import { useRef, useState, useEffect } from 'react';
import { bannerContainerWrap, bannerTitleStyles, breadcrumbLabel, buttonsGrid, breadCrumbs } from './bannerStyle';
import { useHistory } from 'react-router-dom';
import { CorlTooltip } from 'components/CorlTooltip';

const isTextTruncated = (element) => {
  return element.scrollHeight > element.clientHeight || element.scrollWidth > element.clientWidth;
};

const Banner = ({ title, buttonLabel = undefined, breadcrumbs, onClickButton = undefined, icon = undefined, shouldRenderTooltip = false, 'data-testid': dataTestId = 'page-body-title' }) => {
  const history = useHistory();
  const onClickBreadCrumb = (url) => {
    history.push(url);
  };
  const titleRef = useRef(null);
  const [isTitleTruncated, setIsTitleTruncated] = useState(false);

  useEffect(() => {
    if (titleRef.current) {
      setIsTitleTruncated(isTextTruncated(titleRef.current));
    }
  }, [titleRef.current, title]);

  return (
    <>
      <Box sx={bannerContainerWrap}>
        <Grid container>
          <Grid item xs={8}>
            {breadcrumbs && (
              <Breadcrumbs id="breadcrumbs" aria-label="breadcrumb" sx={breadCrumbs} separator={<img alt="" src={Seperator} />}>
                {breadcrumbs &&
                  breadcrumbs.map((breadcrumb, i) => {
                    return (
                      <Link component={'button'} key={i} underline="hover" color="inherit" onClick={() => onClickBreadCrumb(breadcrumb.url)} sx={breadcrumbLabel}>
                        {breadcrumb.text}
                      </Link>
                    );
                  })}
              </Breadcrumbs>
            )}
            {title && (
              <CorlTooltip title={title} enabled={isTitleTruncated && shouldRenderTooltip}>
                <Typography ref={titleRef} data-testid={dataTestId} variant="display3" sx={(theme) => bannerTitleStyles(theme)}>
                  {title}
                </Typography>
              </CorlTooltip>
            )}
          </Grid>

          <Grid item xs={4} sx={buttonsGrid}>
            {buttonLabel && (
              <Button variant="contained" onClick={onClickButton} startIcon={icon}>
                <Typography variant="caption">{buttonLabel}</Typography>
              </Button>
            )}
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default Banner;
